import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=31c5f41a"
import script from "./Recharge.vue?vue&type=script&lang=ts"
export * from "./Recharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports